import {useMediaQuery} from "@/lib/hooks/useMediaQuery.ts";
import {UptimeBar} from "@uptime-com/uptimebar";
import "@uptime-com/uptimebar/styles";
import {type ComponentProps} from "react";
import styles from "./ScrollableUptimeBar.module.scss";

type ScrollableUptimeBarProps = ComponentProps<typeof UptimeBar> & {
  enableMobileScroll?: boolean;
};

export const ScrollableUptimeBar = ({
  maxNumberOfLabels,
  enableMobileScroll = false,
  ...rest
}: ScrollableUptimeBarProps) => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  if (enableMobileScroll && isMobile) {
    return (
      <div className={styles.scrollContainer}>
        <UptimeBar {...rest} maxNumberOfLabels={2} />
      </div>
    );
  }

  return <UptimeBar {...rest} maxNumberOfLabels={maxNumberOfLabels} />;
};
